import { _isEmptyString } from '@/littledash';

/** Maximum number of animals allowed per cage */
export const MAX_CAGE_POPULATION = 15;

/** Maximum character length for cage names */
export const MAX_CAGE_NAME_LENGTH = 50;

/** Validates that a cage name is non-empty and within the maximum length */
export const cageNameValidator = (value: string) =>
  !_isEmptyString(value ?? '') && value.length <= MAX_CAGE_NAME_LENGTH;
